import type { enRecipes } from '../en/recipes';

export const idRecipes: Record<keyof typeof enRecipes, string> = {
  // ---- Editor resep (menu back office) ---------------------------------------------------
  'recipes.action': 'Resep',
  'recipes.openNamed': 'Resep {name}',
  'recipes.openGroupNamed': 'Resep opsi {name}',
  'recipes.countOf': '{count}/{total}',
  'recipes.titleFor': 'Resep — {name}',
  'recipes.itemDesc':
    'Bahan untuk satu porsi. Stok berkurang otomatis setelah pesanan dikirim ke dapur.',
  'recipes.optionsTitle': 'Resep opsi — {name}',
  'recipes.optionsDesc':
    'Bahan tambahan yang dipakai sebuah opsi per porsi (mis. telur ekstra), di luar resep menunya.',
  'recipes.optionDesc': 'Bahan tambahan per porsi dengan opsi ini, di luar resep menunya.',
  'recipes.backToOptions': 'Kembali ke daftar opsi',
  'recipes.noOptions': 'Grup ini belum punya opsi — tambahkan opsi ke grup terlebih dahulu.',
  'recipes.none': 'Belum ada resep',
  'recipes.readOnly': 'Peran Anda dapat melihat resep, tetapi tidak dapat mengubahnya.',
  'recipes.emptyReadOnly':
    'Belum ada resep — setelah manajer menambahkannya, penjualan menu ini akan memakai bahannya.',
  'recipes.inactiveHint': 'Nonaktif: penjualan tidak memakai bahan-bahan ini.',
  'recipes.col.recipe': 'Biaya / food cost',
  'recipes.col.ingredient': 'Bahan',
  'recipes.col.qty': 'Jumlah per porsi',
  'recipes.col.unit': 'Satuan',
  'recipes.col.cost': 'Biaya',
  'recipes.componentsTitle': 'Bahan',
  'recipes.componentsDesc':
    'Jumlah per porsi dalam satuan apa pun dari bahan tersebut; maksimal {max} bahan.',
  'recipes.componentLabel': 'Bahan {n}',
  'recipes.pickItem': 'Pilih bahan',
  'recipes.addComponent': 'Tambah bahan',
  'recipes.removeComponent': 'Hapus bahan {n}',
  'recipes.noItems': 'Belum ada barang persediaan — tambahkan barang di Stok › Barang dulu.',
  'recipes.perPortion': '= {qty} per porsi',
  'recipes.lineCost': 'Biaya',
  'recipes.noAverageCost': 'belum ada harga rata-rata',
  'recipes.costPerPortion': 'Biaya per porsi',
  'recipes.costBasis': 'Berdasarkan harga rata-rata tertimbang cabang saat ini.',
  'recipes.costEmpty': 'Tambahkan bahan untuk melihat biayanya.',
  'recipes.costMissing':
    '{count} bahan belum punya harga rata-rata — biaya muncul setelah ada stok masuk.',
  'recipes.costIncomplete': 'Lengkapi setiap baris untuk melihat biayanya.',
  'recipes.savedCost': 'Resep tersimpan:',
  'recipes.foodCost': 'Food cost',
  'recipes.foodCostOf': 'dari harga jual',
  'recipes.foodCostNoPrice': 'Tidak ada harga jual untuk dibandingkan.',
  'recipes.foodCostHigh': 'Tinggi',
  'recipes.foodCostShort': 'Food cost {percent}',
  'recipes.notes': 'Catatan',
  'recipes.notesHint': 'Catatan penyiapan untuk dapur, maksimal {max} karakter.',
  'recipes.activeLabel': 'Aktif',
  'recipes.activeHint':
    'Resep nonaktif tetap tersimpan, tetapi penjualan tidak lagi memakai bahannya.',
  'recipes.appliesNote':
    'Perubahan berlaku untuk penjualan yang belum diproses; bahan yang sudah diambil dari stok tidak berubah.',
  'recipes.saved': 'Resep {name} disimpan.',
  'recipes.err.item': 'Pilih bahan.',
  'recipes.err.duplicate': 'Bahan ini tercantum dua kali — gabungkan jumlahnya.',
  'recipes.err.qty': 'Isi jumlah di atas 0 (maksimal 3 desimal).',
  'recipes.err.unit': 'Pilih satuan.',
  'recipes.err.qtyPrecision':
    'Jumlah ini tidak dapat dikonversi dengan tepat — gunakan satuan yang lebih kecil.',
  'recipes.err.noComponents': 'Tambahkan setidaknya satu bahan.',
  'recipes.err.tooMany': 'Satu resep maksimal berisi 50 bahan.',
  'recipes.err.notes': 'Catatan maksimal 300 karakter.',
  'recipes.err.exists':
    'Menu ini sudah punya resep (mungkin baru ditambahkan orang lain). Tutup lalu buka lagi untuk mengubahnya.',

  // ---- Pengaturan cabang -------------------------------------------------------------------
  'recipes.settings.location': 'Lokasi pemakaian',
  'recipes.settings.auto': 'Otomatis (lokasi dapur pertama, atau lokasi utama)',
  'recipes.settings.saved': 'Lokasi tersimpan',
  'recipes.settings.hint':
    'Penjualan mengambil bahan resep dari lokasi stok ini. Bahan yang kurang di sana dicatat sebagai kekurangan — penjualan tidak pernah diblokir.',
  'recipes.settings.noAccess': 'Memilih lokasi memerlukan izin melihat stok.',
  'recipes.settings.loadFailed': 'Lokasi stok tidak dapat dimuat — coba lagi nanti.',

  // ---- Pemakaian (/stok/pemakaian) -----------------------------------------------------------
  'stok.consumption.title': 'Pemakaian',
  'stok.consumption.subtitle':
    'Bahan yang terpakai oleh penjualan di {branch}: resep × porsi, dibandingkan dengan yang diambil dari stok.',
  'stok.consumption.readOnly':
    'Peran Anda dapat melihat pemakaian, tetapi tidak dapat memprosesnya — penjualan diproses otomatis setiap menit.',
  'stok.consumption.rangeTitle': 'Periode',
  'stok.consumption.rangeDesc':
    'Menurut tanggal penjualan diproses (bukan tanggal pesanan), maksimal {max} hari.',
  'stok.consumption.rangeTooLong': 'Pilih periode maksimal 93 hari.',
  'stok.consumption.period': '{from} – {to}',
  'stok.consumption.backlogUnknown': 'Penjualan yang menunggu diproses: memuat…',
  'stok.consumption.backlogNone': 'Semua penjualan yang diterima sudah diproses.',
  'stok.consumption.backlogCount': '{count} item penjualan menunggu diproses.',
  'stok.consumption.run.title': 'Proses penjualan',
  'stok.consumption.run.desc':
    'Penjualan yang sudah dikirim ke dapur diproses otomatis setiap menit. Proses sekarang untuk langsung melihat dampaknya pada stok.',
  'stok.consumption.run.action': 'Proses sekarang',
  'stok.consumption.run.busy': 'Memproses…',
  'stok.consumption.run.confirmTitle': 'Proses penjualan sekarang?',
  'stok.consumption.run.confirmBody':
    'Bahan resep dari semua penjualan yang sudah diterima dan belum diproses akan diambil dari lokasi pemakaian.',
  'stok.consumption.run.confirmWarning':
    'Bahan yang tidak tersedia dicatat sebagai kekurangan; stok tidak pernah menjadi minus.',
  'stok.consumption.run.done': '{count} item penjualan diproses.',
  'stok.consumption.run.resultTitle': 'Hasil proses terakhir',
  'stok.consumption.run.processed': 'Diproses',
  'stok.consumption.run.posted': 'Terambil penuh',
  'stok.consumption.run.shortfall': 'Stok kurang',
  'stok.consumption.run.noRecipe': 'Tanpa resep',
  'stok.consumption.run.failed': 'Gagal',
  'stok.consumption.run.reversed': 'Batal, dikembalikan',
  'stok.consumption.run.keptAsWaste': 'Batal, dicatat waste',
  'stok.consumption.run.remaining':
    '{count} item masih menunggu — akan diproses pada putaran berikutnya.',
  'stok.consumption.run.remainingNone': 'Tidak ada lagi yang perlu diproses.',
  'stok.consumption.stat.value': 'Nilai bahan terpakai',
  'stok.consumption.stat.valueDesc':
    'Harga rata-rata yang diambil dari stok, setelah dikurangi pengembalian ({currency})',
  'stok.consumption.stat.items': 'Item penjualan diproses',
  'stok.consumption.stat.itemsDesc': 'Item pesanan yang diterima dalam periode ini',
  'stok.consumption.stat.noRecipe': '{count} tanpa resep',
  'stok.consumption.stat.shortfall': 'Bahan yang kurang',
  'stok.consumption.stat.shortfallDesc': 'Kebutuhan melebihi stok yang bisa dipakai',
  'stok.consumption.stat.shortfallItems': '{count} item penjualan terdampak',
  'stok.consumption.stat.backlog': 'Menunggu',
  'stok.consumption.stat.backlogDesc': 'Item penjualan diterima yang belum diproses',
  'stok.consumption.ingredients': 'Per bahan',
  'stok.consumption.ingredientsDesc':
    'Kebutuhan menurut resep dibandingkan yang diambil dari stok. Kekurangan berarti catatan stok tertinggal dari kenyataan — cocokkan dengan stock opname.',
  'stok.consumption.empty':
    'Belum ada pemakaian pada periode ini — data muncul setelah penjualan menu yang punya resep diproses.',
  'stok.consumption.col.required': 'Kebutuhan',
  'stok.consumption.col.posted': 'Terambil',
  'stok.consumption.col.shortfall': 'Kekurangan',
  'stok.consumption.short': 'Kurang',
  'stok.consumption.shortfalls': 'Penjualan yang tidak terpenuhi',
  'stok.consumption.shortfallsDesc':
    'Item penjualan yang bahannya tidak dapat diambil seluruhnya, beserta alasannya.',
  'stok.consumption.shortfallsEmpty':
    'Semua item penjualan yang diproses terambil penuh dari stok.',
  'stok.consumption.col.menuItem': 'Item penjualan',
  'stok.consumption.col.consumedAt': 'Diproses pada',
  'stok.consumption.col.why': 'Alasan',
  'stok.consumption.status.shortfall': 'Kurang',
  'stok.consumption.status.failed': 'Gagal',
  'stok.consumption.why.shortfall':
    'Stok yang bisa dipakai di lokasi pemakaian tidak cukup (lot kedaluwarsa dan ditahan tidak pernah dipakai).',
  'stok.consumption.why.failed': 'Tidak dapat diproses.',
  'stok.consumption.def.scope': 'Cakupan',
  'stok.consumption.def.required': 'Kebutuhan',
  'stok.consumption.def.posted': 'Terambil',
  'stok.consumption.def.shortfall': 'Kekurangan',
  'stok.consumption.def.value': 'Nilai',
};
